import { z } from "zod";
import { REGEX } from "../../../../../constants";

export const moreAboutAmbassadorCompanySchema = z.object({
  company: z.string().min(1, "Company Name is required"),
  title: z.string().min(1, "Title is required"),
  linkedIn: z
    .string()
    .min(1, "LinkedIn URL is required")
    .refine(
      (val) => !val || REGEX.URL.test(val),
      "LinkedIn URL is not valid"
    ),
});

export type MoreAboutAmbassadorCompanyFormData = z.infer<
  typeof moreAboutAmbassadorCompanySchema
>;

export const defaultValues: MoreAboutAmbassadorCompanyFormData = {
  company: "",
  title: "",
  linkedIn: "",
};

export const PAGE_CONFIG = {
  TITLE: "Tell us about your company",
} as const;
